// reducers/userReducer.js
import {
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
} from "../actions/UserActions";

const initialState = {
  creating: false,
  // offices: [],
  error: null,
  user: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_USER_REQUEST:
      return {
        ...state,
        creating: true,
        error: null,
      };
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        creating: false,
        user: action.payload,
      };
    case CREATE_USER_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
